
// import api from '../../api/editRide';
import api from '../../api/accommodation';
import Vue from 'vue';
import { router } from '../../main';
// import { FormTimepickerPlugin } from 'bootstrap-vue';

function pushAccommodationRoute() {
  if (router.currentRoute.path === '/accommodation') {
    // Same route: no remount; scroll so updated form is visible from the top
    window.scrollTo(0, 0);
    return;
  }
  router.push('/accommodation').catch(() => {});
}

/** Ride row fields from API with id overridden to master template id for update_accommodation_api. */
function mergeNewAccommodationWithMasterId(accommodationNew, masterAccommodation) {
  if (!accommodationNew) {
    return null;
  }
  const masterId = masterAccommodation && masterAccommodation.id != null
    ? masterAccommodation.id
    : null;
  if (masterId != null) {
    return { ...accommodationNew, id: masterId };
  }
  return { ...accommodationNew };
}

const state = {
  accommodationName: '',
  accommodationAddress: '',
  accommodationBookingConfirmation: '',
  accommodationText: '',
  accommodationLink: '',
  accommodationCheckIn: null,//'7/16/2020, 12:00:00 AM',
  accommodationCheckOut: null,//'7/17/2020, 12:00:00 AM',
  accommodationLat: null,
  accommodationLng: null,
  accommodationImage: null,
  accommodationRate: null,
  googleContryAndCity: null,
  accommodationPlaceId: null,
  accommodationPreviewImage:null,
  accommodationPlannedDate: null,
  accommodationId: null,
  accommodationMode: null,
  accommodationFormFromRide: null,
  accommodationFormFromBaseRide: null,
  accommodationDayIndex: null,
  accommodationErrores: [],
  isManagerAccommodationEdit: false,
  accommodationUploadValue: 0,
  accommodationVoucherUrls: [],
  accommodationVoucherUploadValues: {},
  /** Template/master row from API when user compares base vs new on the editor */
  referenceMasterAccommodation: null,
  /** When true, after save navigate to ride map even if isManagerAccommodationEdit (compare / master edit UX) */
  accommodationSaveReturnToRide: false,
  // accommodationFormFromBaseRide: { "address": "וינה", "booking_confirmation": null, "check_in_date": "2021-07-15", "check_out_date": "2021-07-18", "id": 58, "image": "http://127.0.0.1:5000/static/accommodation_pics/9.jpeg", "latitude": "48.2220046", "link": "https://www.meininger-hotels.com/en/hotels/vienna/", "longtitude": "16.3738", "name": "MEININGER Hotel Wien Downtown Franz", "phone": null, "status": "base_trip_accomodation", "text": "Rembrandtstraße 21 \r\n1020 Wien\r\nAustria\r\nhttps://www.meininger-hotels.com/en/hotels/vienna/" },
};

const getters = {
  accommodationName: state => state.accommodationName,
  accommodationAddress: state => state.accommodationAddress,
  accommodationBookingConfirmation: state => state.accommodationBookingConfirmation,
  accommodationText: state => state.accommodationText,
  accommodationLink: state => state.accommodationLink,
  accommodationCheckOut: state => state.accommodationCheckOut,
  accommodationCheckIn: state => state.accommodationCheckIn,
  accommodationLat: state => state.accommodationLat,
  accommodationLng: state => state.accommodationLng,
  accommodationImage: state => state.accommodationImage,
  isAccommodationImage: state => state.accommodationImage != null,
  accommodationRate: state => state.accommodationRate,
  googleContryAndCity: state => state.googleContryAndCity,
  accommodationPlaceId: state => state.accommodationPlaceId,
  accommodationPreviewImage: state => state.accommodationPreviewImage,
  accommodationPlannedDate: state => state.accommodationPlannedDate,
  accommodationId: state => state.accommodationId,
  accommodationMode: state => state.accommodationMode,
  accommodationFormFromRide: state => state.accommodationFormFromRide,
  haveFormFromRide: state => !!state.accommodationFormFromRide,
  haveFormFromRideAndLocation: state => !!state.accommodationFormFromRide.latitude,
  accommodationIsBooked: state => state.accommodationFormFromRide.status=='booked',
  isAccommodationEditMode: state => state.accommodationMode=='edit',
  accommodationFormFromBaseRide: state => state.accommodationFormFromBaseRide,
  accommodationDayIndex: state => state.accommodationDayIndex,
  accommodationFormFromBaseRideCheckinFormatedToBoking:  state => {
    if( state.accommodationFormFromBaseRide.check_in_date != undefined )
      return state.accommodationFormFromBaseRide.check_in_date.split('-')[2]+'-'+state.accommodationFormFromBaseRide.check_in_date.split('-')[1]+'-'+state.accommodationFormFromBaseRide.check_in_date.split('-')[0]
    return '';
  },
  accommodationFormFromBaseRideCheckoutFormatedToBoking: state => {
    if( state.accommodationFormFromBaseRide.check_out_date != undefined )
      return state.accommodationFormFromBaseRide.check_out_date.split('-')[2]+'-'+state.accommodationFormFromBaseRide.check_out_date.split('-')[1]+'-'+state.accommodationFormFromBaseRide.check_out_date.split('-')[0];
    return '';
    },
  haveFormFromBaseRide: state => !!state.accommodationFormFromBaseRide,
  accommodationErrores: state => state.accommodationErrores,
  isManagerAccommodationEdit: state => state.isManagerAccommodationEdit,
  accommodationUploadValue: state => state.accommodationUploadValue,
  accommodationVoucherUrls: state => state.accommodationVoucherUrls,
  accommodationVoucherUploadValues: state => state.accommodationVoucherUploadValues,
  referenceMasterAccommodation: state => state.referenceMasterAccommodation,
  accommodationSaveReturnToRide: state => state.accommodationSaveReturnToRide,

};

const actions = {
  accommodationLoadDefault({commit}){
    commit( 'setAccommodationPlannedDate', null );
    commit( 'setAccommodationId', null );
    commit( 'setAccommodationName', '' );
    commit( 'setAccommodationAddress', '' );
    commit( 'setAccommodationBookingConfirmation', '' );
    commit( 'setAccommodationText', '' );
    commit( 'setAccommodationLink', '' );
    commit( 'setAccommodationCheckOut', null );
    commit( 'setAccommodationCheckIn', null );
    commit( 'setAccommodationLat', null );
    commit( 'setAccommodationLng', null );
    commit( 'setAccommodationImage', null );
    commit( 'setAccommodationGoogleContryAndCity', null );
    commit( 'setAccommodationRate', null );
    commit( 'setAccommodationPlaceId', null );
    commit( 'setAccommodationPreviewImage', null );
    commit( 'setAccommodationMode', null );
    commit( 'setAccommodationFormFromRide', null );
    commit( 'setBasRideAccommodationFormFromRide', null );
    commit( 'setAccommodationDayIndex', null );
    commit( 'setAccommodationErrores', [] );
    commit( 'setIsManagerAccommodationEdit', false );
    commit( 'setAccommodationUploadValue', 0 );
    commit( 'setAccommodationVoucherUrls', [] );
    commit( 'setAccommodationVoucherUploadValues', {} );
    commit( 'setReferenceMasterAccommodation', null );
    commit( 'setAccommodationSaveReturnToRide', false );
  },
  async validateAccmmodationInput( { state, rootState, commit, getters }, accommodation ){
    commit( 'setAccommodationErrores', [] );
    if ( accommodation['name'] == '' )
      state.accommodationErrores.push( "שם מקום הלינה")

    if ( accommodation['name'].length > 140 )
      state.accommodationErrores.push( "שם המיקום ארוך מידי")

    // Skip date validation for manager accommodation edits
    if ( !getters.isManagerAccommodationEdit ) {
      // Check if dates are missing or empty (handle null, undefined, empty string, or whitespace)
      const checkIn = accommodation['checkIn'];
      const checkOut = accommodation['checkOut'];
      const isCheckInMissing = !checkIn || (typeof checkIn === 'string' && checkIn.trim() === '');
      const isCheckOutMissing = !checkOut || (typeof checkOut === 'string' && checkOut.trim() === '');
      
      if ( isCheckInMissing || isCheckOutMissing ) {
        state.accommodationErrores.push( "יש להכניס תאריך כניסה ויציאה עבור מקום הלינה")
      } else {
        var rideFirstDay = Date.parse( rootState.ride.ride.ride.start_date.split("-")[1] + "-" + rootState.ride.ride.ride.start_date.split("-")[0] + "-" + rootState.ride.ride.ride.start_date.split("-")[2] );
        var rideLastDay = Date.parse( rootState.ride.ride.ride.end_date.split("-")[1] + "-" + rootState.ride.ride.ride.end_date.split("-")[0] + "-" + rootState.ride.ride.ride.end_date.split("-")[2] );
        var formCheckin = Date.parse(  accommodation['checkIn'].split("-")[1] + "-" + accommodation['checkIn'].split("-")[0] + "-" + accommodation['checkIn'].split("-")[2]  );
        var formCheckOut = Date.parse( accommodation['checkOut'].split("-")[1] + "-" + accommodation['checkOut'].split("-")[0] + "-" + accommodation['checkOut'].split("-")[2]  );

        if ( formCheckin < rideFirstDay )
          state.accommodationErrores.push( "תאריך ההזמנה קטן מיום תחילת הטיול")

        if ( formCheckOut > rideLastDay )
          state.accommodationErrores.push( "תאריך ההזמנה גדול מיום סיום הטיול")
      }
    }
    // we shjould check that we dont have dubell boking as well!!
    if ( accommodation['bookingConfirmation'] && accommodation['bookingConfirmation'].length > 40 )
      state.accommodationErrores.push( "מספר אישור הזמנה ארוך מידי")

    if ( accommodation['lat'] == null )
      state.accommodationErrores.push( "נא להוסיף מיקום על המפה")

    // Check if image is uploading or waiting for download URL
    if ( state.accommodationUploadValue > 0 && state.accommodationUploadValue < 100 ) {
      state.accommodationErrores.push( "התמונה עדיין נטענת, אנא המתן לסיום ההעלאה")
    } else if ( state.accommodationUploadValue === 100 ) {
      // Upload is complete but we're waiting for the download URL
      // If image is still null, we haven't received the new URL yet
      if ( state.accommodationImage == null ) {
        state.accommodationErrores.push( "ממתין לקבלת קישור התמונה, אנא המתן")
      }
    }

    if (Object.values(state.accommodationVoucherUploadValues).some(v => v > 0 && v < 100)) {
      state.accommodationErrores.push('accommodationValidationVoucherUploading');
    }

    if ( state.accommodationErrores.length > 0 )
      return false
    return true;
  },
  goToBaseRideAccommodation({ commit, dispatch }, { baseRideAccommodation, dayIndex = null }){
    dispatch('accommodationLoadDefault');
    commit('setBasRideAccommodationFormFromRide', baseRideAccommodation );
    commit('setAccommodationDayIndex', dayIndex);
    pushAccommodationRoute();
  },
  addAccommodationFromSearchToRide({ rootState, commit, dispatch }, { searchAccommodation, dayIndex }) {
    // Get the day's information to extract dates
    const allRide = rootState.ride.ride;
    const dailyActivities = allRide?.attractionsByDay?.[dayIndex];
    
    // Convert search accommodation to base accommodation format
    const baseAccommodation = {
      name: searchAccommodation.name || '',
      latitude: searchAccommodation.latitude || null,
      longtitude: searchAccommodation.longtitude || null,
      image: searchAccommodation.image || null,
      text: searchAccommodation.text || '',
      link: searchAccommodation.link || '',
      cuntry_and_city: searchAccommodation.cuntry_and_city || '',
      rate: searchAccommodation.rate || null,
      address: searchAccommodation.address || '',
      place_id: searchAccommodation.place_id || null,
      // Use dates from the day if available, otherwise from base_trip_accommodation
      check_in_date: dailyActivities?.base_trip_accommodation?.check_in_date || null,
      check_out_date: dailyActivities?.base_trip_accommodation?.check_out_date || null,

    };
    
    // Set the base accommodation form
    dispatch('accommodationLoadDefault');
    commit('setBasRideAccommodationFormFromRide', baseAccommodation);
    
    // Populate the form fields from the base accommodation
    dispatch('uploadAccommodationFromBaseRide');
    
    // Navigate to accommodation form
    pushAccommodationRoute();
  },
  goToBokingDotCom({ commit, dispatch }, baseRideAccommodation ){
    dispatch('accommodationLoadDefault');
    commit('setBasRideAccommodationFormFromRide', baseRideAccommodation );
    router.push('/booking' );
  },
  goToRideAccommodation({ commit, dispatch }, rideAccommodation ){
    dispatch('accommodationLoadDefault');
    commit('setAccommodationFormFromRide', rideAccommodation );
    // Sync flat form fields; Accommodation.vue created() also runs this on first mount but not when staying on /accommodation
    dispatch('uploadAccommodationIfBooked');
    pushAccommodationRoute();
  },
  /**
   * Master compare modal: open editor with new row fields, master id for save URL, template reference, manager UX, return to ride after save.
   * uploadAccommodationIfBooked is required when the route does not remount (same /accommodation).
   */
  openAccommodationFromMasterCompare({ commit, dispatch }, { accommodationNew, masterAccommodation }) {
    if (!accommodationNew) {
      return;
    }
    const rideAccommodation = mergeNewAccommodationWithMasterId(accommodationNew, masterAccommodation);
    dispatch('accommodationLoadDefault');
    if (masterAccommodation) {
      commit('setReferenceMasterAccommodation', masterAccommodation);
    }
    commit('setIsManagerAccommodationEdit', true);
    commit('setAccommodationSaveReturnToRide', true);
    commit('setAccommodationFormFromRide', rideAccommodation);
    commit('setAccommodationMode', 'edit');
    dispatch('uploadAccommodationIfBooked');
    pushAccommodationRoute();
  },
  uploadAccommodationIfBooked({ getters, commit } ){
    const accommodation = getters.accommodationFormFromRide;
    if( getters.haveFormFromRide == false ){ return; }
    commit('setAccommodationName', accommodation.name );
    commit('setAccommodationGoogleContryAndCity', accommodation.cuntry_and_city );
    commit('setAccommodationAddress', accommodation.address );
    commit('setAccommodationBookingConfirmation', accommodation.booking_confirmation );
    commit('setAccommodationText', accommodation.text );
    commit('setAccommodationLink', accommodation.link );
    commit('setAccommodationLat', accommodation.latitude );
    commit('setAccommodationLng', accommodation.longtitude );
    commit('setAccommodationCheckIn', accommodation.check_in_date );
    commit('setAccommodationCheckOut', accommodation.check_out_date );
    commit('setAccommodationImage', accommodation.image );
    commit('setAccommodationPlaceId', accommodation.place_id || null );
    commit('setAccommodationVoucherUrls', accommodation.voucherUrls || []);
  },
  uploadAccommodationFromBaseRide({ getters, commit } ){
    const accommodation = getters.accommodationFormFromBaseRide;
    if( !accommodation || Object.keys(accommodation).length === 0 ){ return; }
    commit('setAccommodationName', accommodation.name || '' );
    commit('setAccommodationGoogleContryAndCity', accommodation.cuntry_and_city || '' );
    commit('setAccommodationAddress', accommodation.address || '' );
    commit('setAccommodationBookingConfirmation', accommodation.booking_confirmation || '' );
    commit('setAccommodationText', accommodation.text || '' );
    commit('setAccommodationLink', accommodation.link || '' );
    commit('setAccommodationLat', accommodation.latitude || null );
    commit('setAccommodationLng', accommodation.longtitude || null );
    commit('setAccommodationCheckIn', accommodation.check_in_date || null );
    commit('setAccommodationCheckOut', accommodation.check_out_date || null );
    commit('setAccommodationImage', accommodation.image || null );
    commit('setAccommodationRate', accommodation.rate || null );
    commit('setAccommodationPlaceId', accommodation.place_id || null );
    commit('setAccommodationVoucherUrls', accommodation.voucherUrls || []);
  },
  async deleteTheAccommodation({ rootState, getters, dispatch } ){
    const accommodationId = getters.accommodationFormFromRide.id;
    const { apptoken } = rootState.appauth;
    dispatch( 'showModal', "loadingIcon" );
    const response = await api.deleteAccommodation( apptoken,
                                                    accommodationId);
    const rideId = rootState.ride.rideId;
    if( response.data.ServerMassageCode != "success" ){
      dispatch( 'showModalWithParameters',
      { errorNumber : response.data.ServerMassageCode,
        type:'textConverter' 
      } );
      return
    }
    else{
      dispatch( 'showModal', "" );
    }

    await dispatch('accommodationLoadDefault');
    router.push('/single_ride_with_map/' + rideId );
  },
  async directUpdateMasterAccommodationFromCompare({ dispatch, rootState }, { rideId, isManagerEdit, accommodationNew, masterAccommodation }) {
    const { apptoken } = rootState.appauth;
    const masterId = masterAccommodation && masterAccommodation.id != null
      ? masterAccommodation.id
      : accommodationNew.id;
    const accommodation = {
      name: accommodationNew.name || '',
      contryAndCity: accommodationNew.cuntry_and_city || '',
      address: accommodationNew.address || '',
      bookingConfirmation: accommodationNew.booking_confirmation || '',
      text: accommodationNew.text || '',
      link: accommodationNew.link || '',
      lat: accommodationNew.latitude || null,
      lng: accommodationNew.longtitude || null,
      image: accommodationNew.image || null,
      place_id: accommodationNew.place_id || null,
      voucherUrls: accommodationNew.voucherUrls || [],
    };
    if (accommodationNew.check_in_date) {
      accommodation.checkIn = accommodationNew.check_in_date.toString();
    }
    if (accommodationNew.check_out_date) {
      accommodation.checkOut = accommodationNew.check_out_date.toString();
    }
    dispatch('showModal', 'loadingIcon');
    const response = await api.updateAccommodation(apptoken, masterId, accommodation);
    const data = response.data;
    await dispatch('showModal', '');
    if (data.ServerMassageCode !== 'success') {
      dispatch('showModalWithParameters', { errorNumber: data.ServerMassageCode, type: 'textConverter' });
      return;
    }
    dispatch('completeAccommodationUpdateAfterMasterCompare', { rideId, isManagerEdit });
  },

  completeAccommodationUpdateAfterMasterCompare({ dispatch, getters }, { rideId, isManagerEdit }) {
    const saveReturnToRide = getters.accommodationSaveReturnToRide;
    dispatch('accommodationLoadDefault');
    if (saveReturnToRide || !isManagerEdit) {
      router.push('/single_ride_with_map/' + rideId);
    } else {
      router.push('/ride_manager_attraction');
    }
  },
  async updateTheAccommodation({ rootState, getters, dispatch } ){
    const accommodationId = getters.accommodationFormFromRide.id;
    const rideId = rootState.ride.rideId;
    const isManagerEdit = getters.isManagerAccommodationEdit;
    const saveReturnToRide = getters.accommodationSaveReturnToRide;
    var accommodation = await dispatch('getupdatedFormaccommodation');
    const { apptoken } = rootState.appauth;
    if (! await dispatch( 'validateAccmmodationInput',  accommodation))
      return
    dispatch( 'showModal', "loadingIcon" );
    const response = await api.updateAccommodation(  apptoken,
                                                     accommodationId,
                                                     accommodation);
    const data = response.data;

    if( data.ServerMassageCode != "success" ){
      dispatch( 'showModalWithParameters',
      { errorNumber : data.ServerMassageCode,
        type:'textConverter' 
      } );
      return
    }
    else{
      dispatch( 'showModal', "" );
    }

    if (
      data.shouldAskMasterUpdate &&
      data.masterAccommodation &&
      data.accommodationNew
    ) {
      dispatch( 'showModalWithParameters', {
        inerModalParameters: {
          masterAccommodation: data.masterAccommodation,
          accommodationNew: data.accommodationNew,
          rideId,
          isManagerEdit,
        },
        type: 'masterAccommodationCompare',
      } );
      return;
    }

    await dispatch('accommodationLoadDefault');
    // Manager list edit -> manager page; compare flow may set accommodationSaveReturnToRide to use ride map instead
    if (saveReturnToRide || !isManagerEdit) {
      router.push('/single_ride_with_map/' + rideId );
    } else {
      router.push('/ride_manager_attraction');
    }
  },
  async createAccommodation({ rootState, dispatch } ){
    const rideId = rootState.ride.rideId;
    var accommodation = await dispatch('getupdatedFormaccommodation');
    if (! await dispatch( 'validateAccmmodationInput',  accommodation))
      return
    const { apptoken } = rootState.appauth;
    dispatch( 'showModal', "loadingIcon" );
    const response = await api.createAccommodation(  apptoken,
                                                    rideId,
                                                    accommodation);
    const data = response.data;
    await dispatch( 'showModal', '' );
    if( data.ServerMassageCode != "success" ){
      dispatch( 'showModalWithParameters',
      { errorNumber : data.ServerMassageCode,
        type:'textConverter' 
      } );
      return
    }

    if (
      data.shouldAskMasterUpdate &&
      data.masterAccommodation &&
      data.accommodationNew
    ) {
      dispatch( 'showModalWithParameters', {
        inerModalParameters: {
          masterAccommodation: data.masterAccommodation,
          accommodationNew: data.accommodationNew,
          rideId,
          isManagerEdit: false,
        },
        type: 'masterAccommodationCompare',
      } );
      return;
    }

    dispatch('accommodationLoadDefault');
    router.push('/single_ride_with_map/' + rideId );

  },
  getupdatedFormaccommodation({state}){
    var accommodation = {};
    accommodation['name'] = state.accommodationName;
    accommodation['address'] = state.accommodationAddress;
    accommodation['bookingConfirmation'] = state.accommodationBookingConfirmation;
    accommodation['text'] = state.accommodationText;
    accommodation['link'] = state.accommodationLink;
    if( state.accommodationCheckIn )
      accommodation['checkIn'] = state.accommodationCheckIn.toString();
    if( state.accommodationCheckOut )
      accommodation['checkOut'] = state.accommodationCheckOut.toString();
    accommodation['lat'] = state.accommodationLat;
    accommodation['lng'] = state.accommodationLng;
    accommodation['contryAndCity'] = state.googleContryAndCity;
    accommodation['image'] = state.accommodationImage;
    accommodation['rate'] = state.accommodationRate;
    accommodation['place_id'] = state.accommodationPlaceId;
    accommodation['voucherUrls'] = state.accommodationVoucherUrls;
    return accommodation;
  },

  editManagerAccommodation({ commit, dispatch }, accommodationDataOrObject){
    dispatch('accommodationLoadDefault');
    
    // Handle both old format (just accommodationData) and new format ({ accommodationData, isManagerEdit })
    let accommodationData;
    let isManagerEdit = false;
    
    // Check if this is the new format by looking for isManagerEdit property
    if (accommodationDataOrObject && typeof accommodationDataOrObject === 'object' && 'isManagerEdit' in accommodationDataOrObject) {
      // New format: { accommodationData, isManagerEdit }
      accommodationData = accommodationDataOrObject.accommodationData;
      isManagerEdit = accommodationDataOrObject.isManagerEdit || false;
    } else {
      // Old format: just accommodationData
      accommodationData = accommodationDataOrObject;
    }
    
    // Set flag to indicate this is a manager accommodation edit (after loadDefault to avoid reset)
    if (isManagerEdit) {
      commit('setIsManagerAccommodationEdit', true);
    }
    // Set accommodation form from the provided data
    commit('setAccommodationFormFromRide', accommodationData);
    commit('setAccommodationMode', 'edit');
    dispatch('uploadAccommodationIfBooked');
    pushAccommodationRoute();
  },

  cleanHistoryAndEditAccommodation({ dispatch }, accommodationData ){
    dispatch( 'cleanAllRideInformation' );
    // Pass isManagerEdit flag to editManagerAccommodation
    dispatch('editManagerAccommodation', { accommodationData, isManagerEdit: true });
  },
};

const mutations = {
  setAccommodationFormFromRide: (state, accommodationFormFromRide) => {
    state.accommodationFormFromRide = accommodationFormFromRide;
  },
  setBasRideAccommodationFormFromRide: (state, accommodationFormFromBaseRide) => {
    state.accommodationFormFromBaseRide = accommodationFormFromBaseRide;
  },
  setAccommodationName: (state, accommodationName) => {
    state.accommodationName = accommodationName;
  },
  setAccommodationAddress: (state, accommodationAddress) => {
    state.accommodationAddress = accommodationAddress;
  },
  setAccommodationBookingConfirmation: (state, accommodationBookingConfirmation) => {
    state.accommodationBookingConfirmation = accommodationBookingConfirmation;
  },
  setAccommodationText: (state, accommodationText) => {
    state.accommodationText = accommodationText;
  },
  setAccommodationLink: (state, accommodationLink) => {
    state.accommodationLink = accommodationLink;
  },
  setAccommodationCheckOut: (state, accommodationCheckOut) => {
    state.accommodationCheckOut = accommodationCheckOut;
  },
  setAccommodationCheckIn: (state, accommodationCheckIn) => {
    state.accommodationCheckIn = accommodationCheckIn;
  },
  setAccommodationLat: (state, accommodationLat) => {
    state.accommodationLat = accommodationLat;
  },
  setAccommodationLng: (state, accommodationLng) => {
    state.accommodationLng = accommodationLng;
  },
  setAccommodationImage: (state, accommodationImage) => {
    state.accommodationImage = accommodationImage;
    // Reset upload value when image is set
    if (accommodationImage != null) {
      state.accommodationUploadValue = 0;
    }
  },
  setAccommodationGoogleContryAndCity: (state, googleContryAndCity) => {
    state.googleContryAndCity = googleContryAndCity;
  },
  setAccommodationRate: (state, rate) => {
    state.accommodationRate = rate;
  },
  setAccommodationPlaceId: (state, placeId) => {
    state.accommodationPlaceId = placeId;
  },
  setAccommodationPreviewImage: (state, accommodationPreviewImage) => {
    state.accommodationPreviewImage = accommodationPreviewImage;
  },
  setAccommodationPlannedDate: (state, plannedDate) => {
    state.accommodationPlannedDate = plannedDate;
  },
  setAccommodationId: (state, attractionId) => {
    state.accommodationId = attractionId;
  },
  setAccommodationMode: (state, mode) => {
    state.accommodationMode = mode;
  },
  setAccommodationErrores: ( state, errores ) => {
    state.accommodationErrores = errores
  },
  setAccommodationDayIndex: ( state, dayIndex ) => {
    state.accommodationDayIndex = dayIndex;
  },
  setIsManagerAccommodationEdit: ( state, value ) => {
    state.isManagerAccommodationEdit = value;
  },
  setAccommodationUploadValue: (state, uploadValue) => {
    state.accommodationUploadValue = uploadValue;
  },
  setAccommodationVoucherUrls: (state, urls) => {
    state.accommodationVoucherUrls = Array.isArray(urls) ? urls : [];
  },
  setAccommodationVoucherUploadValues: (state, values) => {
    state.accommodationVoucherUploadValues = values || {};
  },
  addAccommodationVoucherUrl: (state, url) => {
    state.accommodationVoucherUrls.push(url);
  },
  removeAccommodationVoucherUrl: (state, index) => {
    state.accommodationVoucherUrls.splice(index, 1);
  },
  setAccommodationVoucherUploadValue: (state, { index, value }) => {
    Vue.set(state.accommodationVoucherUploadValues, index, value);
  },
  clearAccommodationVoucherUploadValue: (state, index) => {
    Vue.delete(state.accommodationVoucherUploadValues, index);
  },
  setReferenceMasterAccommodation: (state, reference) => {
    state.referenceMasterAccommodation = reference;
  },
  setAccommodationSaveReturnToRide: (state, value) => {
    state.accommodationSaveReturnToRide = !!value;
  },

};

export default {
  state,
  getters,
  actions,
  mutations
};
